import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiService } from "./api";

export interface ShareDouyinH5Request {
  videoUrls?: string[];
  imageUrls?: string[];
}

export interface ShareDouyinH5Response {
  video_url: string;
  share_scheme: string;
}


class ShareDouyinH5Data {
  @Required("Share scheme cannot be empty")
  @IsString("Share scheme must be a string")
  shareScheme: string;
}

const transformAndValidateData = (
  response: ShareDouyinH5Response
): ShareDouyinH5Data => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ShareDouyinH5Data);
  } catch (error) {
    console.error("Share douyin h5 data validation failed:", error.message);
    throw error;
  }
};

// 分享到抖音H5
export const shareDouyinH5 = async ({
  videoUrls,
  imageUrls,
}: ShareDouyinH5Request) => {
  const res = await api.post<ShareDouyinH5Response>("/share/douyin/h5", {
    video_urls: videoUrls,
    image_urls: imageUrls,
  });
  return transformAndValidateData(res.data);
};
